/**
 * Color theme selection section.
 */

import { observer } from 'mobx-react-lite';
import { bibleState, type ColorTheme } from '@/state/bible-state';

/** Color theme options with display names and preview color */
const colorThemes: { value: ColorTheme; label: string; preview: string }[] = [
  { value: 'default', label: 'Default', preview: 'bg-cyan-500' },
  { value: 'ocean', label: 'Ocean', preview: 'bg-blue-500' },
  { value: 'forest', label: 'Forest', preview: 'bg-emerald-500' },
  { value: 'sunset', label: 'Sunset', preview: 'bg-orange-500' },
  { value: 'royal', label: 'Royal', preview: 'bg-purple-500' },
  { value: 'earth', label: 'Earth', preview: 'bg-amber-700' },
];

export const ThemeSection = observer(function ThemeSection() {
  const colorTheme = bibleState.colorTheme;

  return (
    <section className="border-t border-stone-200/50 pt-4 dark:border-stone-700/50">
      <h2 className="mb-4 text-lg font-semibold text-stone-800 dark:text-stone-200">Theme</h2>
      <p className="mb-3 text-xs text-stone-500 dark:text-stone-400">
        Choose a color accent for the interface
      </p>
      <div className="grid grid-cols-3 gap-2">
        {colorThemes.map((theme) => (
          <button
            key={theme.value}
            onClick={() => bibleState.setColorTheme(theme.value)}
            className={`flex items-center gap-2 rounded-xl border p-3 transition-all ${
              colorTheme === theme.value
                ? 'border-primary bg-primary/10'
                : 'border-stone-200 hover:border-stone-300 dark:border-stone-700 dark:hover:border-stone-600'
            }`}
          >
            <span className={`h-4 w-4 rounded-full ${theme.preview}`} />
            <span
              className={`text-xs font-medium ${
                colorTheme === theme.value ? 'text-primary' : 'text-stone-600 dark:text-stone-400'
              }`}
            >
              {theme.label}
            </span>
          </button>
        ))}
      </div>
    </section>
  );
});
